import React, {useState} from 'react';
import {TextField} from '@ui/forms/input-field/text-field/text-field';
import {EditIcon} from '@ui/icons/material/Edit';

interface EditableTextProps {
  name: string;
  value: string;
  onChange: (newValue: string) => void;
}

const EditableText: React.FC<EditableTextProps> = ({name, value, onChange}) => {
  const [editing, setEditing] = useState<boolean>(false);
  const handleBlur = () => setEditing(false);
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      setEditing(false);
      onChange(e.currentTarget.value);
    }
  };

  return (
    <div>
      {!editing ? (
        <span onClick={() => setEditing(true)}>
          {value} <EditIcon size={'2xs'} />
        </span>
      ) : (
        <TextField
          name={name}
          type="text"
          defaultValue={value}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          autoFocus
        />
      )}
    </div>
  );
};

export default EditableText;
